import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export const StaffOrderSearch = () => {
    const navigate = useNavigate();
    const [searchId, setSearchId] = useState('');

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmed = searchId.trim();
        if (trimmed) {
            navigate(`/staff/orderdetails/${trimmed}`);
        }
    };

    return (
        <div className="container mx-auto px-2 sm:px-4 py-4 sm:py-6">
            <h1 className="text-2xl font-bold text-slate-800 mb-4 sm:mb-6">Order Search</h1>

            <div className="bg-white shadow rounded-lg p-6">
                <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-3">
                    <div className="relative flex-1">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Enter Order ID"
                            value={searchId}
                            onChange={(e) => setSearchId(e.target.value)}
                            className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                    <button
                        type="submit"
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 hover:cursor-pointer"
                    >
                        <Search className="h-4 w-4" />
                        <span>Search</span>
                    </button>
                </form>
            </div>
        </div>
    );
};
